var vskoRadioGroup = angular.module('vskoRadioGroup', []);

vskoRadioGroup.directive('vskoRadioGroup', [function () {
  return {
    restrict: 'E',
    template: require('./vsko-radio-group.html'),
    transclude: true,
    required: ['name', 'ngModel'],
    scope: {
      name: '@',
      inline: '@',
      ngModel: '='
    },
    controller: ['$scope', function ($scope) {
      this.getName = function () {
        return $scope.name;
      };

      this.isInline = function () {
        return $scope.inline || false;
      };

      this.getModel = function () {
        return $scope.ngModel;
      };
    }]
  };
}]);

vskoRadioGroup.directive('vskoRadio', [function () {
  return {
    require: '^^vskoRadioGroup',
    restrict: 'E',
    template: require('./vsko-radio.html'),
    transclude: true,
    scope: {
      value: '@',
      ngDisabled: '='
    },
    controllerAs: 'vskoRadioGroupCtrl',
    link: function ($scope, element, attrs, vskoRadioGroupCtrl) {
      $scope.name = vskoRadioGroupCtrl.getName();
      $scope.inline = vskoRadioGroupCtrl.isInline();
      $scope.ngModel = vskoRadioGroupCtrl.getModel();
    }
  };
}]);
